import type { GameState } from './types';
import { appendEvent } from './event-log';

export interface StoneSkinBlockOptions {
  actorId: string | null;
  sourceId: string;
  allowSelfBlock?: boolean;
}

/**
 * Consume a player's active Stone Skin shield for an incoming hostile effect.
 *
 * Self-inflicted effects are not blocked unless allowSelfBlock is explicitly set.
 * Missing players and inactive shields return false without throwing so callers can
 * use this as a lightweight guard in broad damage/effect paths.
 */
export function tryBlockWithStoneSkin(
  state: GameState,
  blockerId: string,
  options: StoneSkinBlockOptions,
): boolean {
  const { actorId, sourceId, allowSelfBlock = false } = options;
  const blocker = state.players.get(blockerId);
  if (blocker == null) return false;
  if (!blocker.statusEffects.stoneSkin.active) return false;
  if (!allowSelfBlock && actorId === blockerId) return false;

  blocker.statusEffects.stoneSkin.active = false;
  appendEvent(state, {
    type: 'status_effect_expired',
    playerId: blockerId,
    effectType: 'stoneSkin',
  });
  appendEvent(state, {
    type: 'item_blocked_stoneskin',
    playerId: actorId ?? blockerId,
    casterId: actorId ?? sourceId,
    itemId: sourceId,
    blockerId,
  });
  return true;
}
